<template lang="pug">
v-content
  .bg
    div(style="background-image:url(/static/icons/login_bg_1.jpg)")
    div(style="background-image:url(/static/icons/login_bg_2.jpg)")
    div(style="background-image:url(/static/icons/login_bg_3.jpg)")
  v-container(fluid fill-height)
    v-layout(justify-center)
      v-flex(xs12 sm8 md4)
        v-card.elevation-0.padding-top(color="transparent" dark)
          v-layout(row wrap)
            v-flex.text-xs-center(xs12)
              img.logo-main.mb-4(src="/static/icons/login_logo.svg")
          v-card-text
            v-form(ref="form" autocomplete="off")
              v-text-field(v-model="username" name="login" autocomplete="off" :label="$tf('login.username.label')" type="text" color="grey lighten-1" background-color="grey lighten-1" height="1" outline clearable :error-messages="authMessage" validate-on-blur :rules="[rules.required]" @keyup.enter="login")
              v-text-field(v-model="password" name="password" autocomplete="off" :label="$tf('login.password.label')" :type="showPassword ? 'text' : 'password'" color="grey lighten-1" background-color="grey lighten-1" height="1" outline clearable :error-messages="authMessage" validate-on-blur :rules="[rules.required]" @keyup.enter="login" :append-icon="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'" @click:append="showPassword = !showPassword")
          v-card-actions.ml-2
            v-layout(row wrap)
              v-flex.pb-5(xs12)
                v-btn(color="orange darken-1" block large @click="login" :loading="authenticating") {{ $tf("login.login") }}
              v-flex.text-xs-center(xs12)
                img.logo-bi(src="/static/icons/logo_beintech.svg")

</template>
<script>
import store from '@/store'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Login',

  data() {
    return {
      username: localStorage.getItem('store/auth/userName'),
      password: null,
      showPassword: false,
      errorMessage: null,
    }
  },

  computed: {
    ...mapGetters({
      authMessage: 'auth/authMessage',
      authenticating: 'auth/authenticating',
    }),
  },

  watch: {
    username() {
      store.commit('auth/set', { type: 'authMessage', value: null })
    },
    password() {
      store.commit('auth/set', { type: 'authMessage', value: null })
    },
  },

  // Prevent back button if user authenticated
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('store/auth/authenticated') === 'true') {
      next(false)
    } else {
      next()
    }
  },

  methods: {
    ...mapActions({
      _login: 'auth/login',
    }),

    login() {
      if (this.$refs.form.validate()) {
        this.username = this.username ? this.username.trim() : this.username
        this.password = this.password ? this.password.trim() : this.password
        localStorage.setItem('store/auth/userName', this.username)
        this._login({ username: this.username ? this.username.toLowerCase() : this.username, password: this.password })
      }
    },
  },
}
</script>
<style lang="stylus">
.logo-main
  width 330px
  max-width 70vw
  animation headerIntro 3s ease

.logo-inno
  height 28px
  margin-left 2px

.logo-bi
  height 32px

.padding-top
  padding-top 12vh

.bg
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  z-index 0
  background-color #000
  & > div
    background-size cover
    background-position center center
    width 100%
    height 100%
    position absolute
    top 0
    left 0
    opacity 0
    visibility hidden
    transition opacity 3s ease, visibility 3s
    animation bg 30s linear infinite
    &:nth-child(1)
      animation-delay 10s
    &:nth-child(2)
      animation-delay 20s

@media (max-width: 767px)
  .bg
    & > div
      &:nth-child(1)
        background-position center center
      &:nth-child(2)
        background-position right center
      &:nth-child(3)
        background-position right center

@keyframes bg {
  0% {
    transform scale(1,1)
    visibility visible
    opacity 0
  }
  5% {
    opacity 0.5
  }
  33% {
    opacity 0.5
  }
  38% {
    transform scale(1.2, 1.2)
    opacity 0
  }
  39% {
    visibility hidden
  }
  100% {
    visibility hidden
    opacity 0
  }
}

@keyframes headerIntro {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue